import { DashboardOpenMode } from "MyDashboards/state/types";
import Editdashboard from "MyDashboards/views/EditDashboard/EditDashboard";
import CreateDashboardToolbar from "components/toolbars/CreateDashboardToolbar";
import PageContainer from "design/layouts/PageContainer";
import Page from "design/pages/Page";
import React from "react";

const EditDashboardPage = () => {
  return (
    <Page Toolbar={CreateDashboardToolbar} mode={DashboardOpenMode.edit}>
      <PageContainer width="100%">
        <Editdashboard />
      </PageContainer>
    </Page>
  );
};

export default EditDashboardPage;
